import { __styles, mergeClasses } from '@griffel/react';
import { useTagGroupStyles_unstable } from '@fluentui/react-tags';
import { tokens } from '@fluentui/react-theme';
import { tagSizeToTagPickerSize } from '../../utils/tagPicker2Tag';
export const tagPickerGroupClassNames = {
  root: 'fui-TagPickerGroup'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    Eh141a: "fni485r",
    B7ck84d: "f1ewtqcl",
    Bceei9c: "f113hnb5"
  },
  medium: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fa2pw7h",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "fkln5zr"
  },
  large: {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fc0zr7g",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "f1eyhf9v"
  },
  "extra-large": {
    Byoj8tv: 0,
    uwmqm3: 0,
    z189sj: 0,
    z8tnut: 0,
    B0ocmuz: "fc0zr7g",
    i8kkvl: 0,
    Belr9w4: 0,
    rmohyg: "f1eyhf9v"
  }
}, {
  d: [".fni485r{flex-wrap:wrap;}", ".f1ewtqcl{box-sizing:border-box;}", ".f113hnb5{cursor:text;}", [".fa2pw7h{padding:var(--spacingVerticalSNudge) 0 var(--spacingVerticalSNudge) 0;}", {
    p: -1
  }], [".fkln5zr{gap:var(--spacingHorizontalXS);}", {
    p: -1
  }], [".fc0zr7g{padding:var(--spacingVerticalS) 0 var(--spacingVerticalS) 0;}", {
    p: -1
  }], [".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}", {
    p: -1
  }], [".fc0zr7g{padding:var(--spacingVerticalS) 0 var(--spacingVerticalS) 0;}", {
    p: -1
  }], [".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}", {
    p: -1
  }]]
});
/**
 * Apply styling to the TagPickerGroup slots based on the state
 */
export const useTagPickerGroupStyles_unstable = state => {
  'use no memo';

  useTagGroupStyles_unstable(state);
  const styles = useStyles();
  state.root.className = mergeClasses(tagPickerGroupClassNames.root, styles[tagSizeToTagPickerSize(state.size)], styles.root, state.root.className);
  return state;
};